<template>
  <v-tour name="landingPageTour" :steps="steps"></v-tour>
</template>

<script>
export default {
  name: 'landingPageTour',
  data() {
    return {
      steps: [
        {
          target: '#an_door',
          content: `Click on the text boxes to learn more`,
          params: {
            placement: 'top'
          }
        },
        {
          target: '#toggle-annotations',
          content: 'Here you can turn the text boxes on and off',
          params: {
            placement: 'right'
          }
        },
        {
          target: '#repeat-landing-tour',
          content: 'Repeat this guided tour',
          params: {
            placement: 'right'
          }
        },

        {
          target: '#continue-interactive',
          content: 'Once you finished exploring click on continue',
          params: {
            placement: 'top'
          }
        }
      ]
    }
  }
}
</script>
